export const initialState = {
  queueItems: [],
  unsubscribeReasons: [],
  activeStep: 'initial',
  activeReason: null,
  refund: null,
  isFetched: false,
  hasError: false,
}

export const update = (state, payload) => ({
  ...state,
  ...payload,
})
